export const unknownExtension = "other";

export type KnownExtensionType = keyof typeof KnownExtension;

/**
 * This list supports uppercase as well for all of these extension types
 */
export enum KnownExtension {
  "7z",
  "folder",
  "directory",
  "accdb",
  "ai",
  "apk",
  "aspx",
  "avi",
  "bat",
  "bmp",
  "carpeta",
  "cell",
  "config",
  "cs",
  "css",
  "csv",
  "db",
  "dll",
  "doc",
  "docm",
  "docx",
  "dossier",
  "dotx",
  "eml",
  "eps",
  "exe",
  "gif",
  "gz",
  "htm",
  "html",
  "hwp",
  "indd",
  "jar",
  "java",
  "jpeg",
  "jpg",
  "js",
  "json",
  "kansio",
  "key",
  "lnk",
  "log",
  "m4a",
  "map",
  "mapp",
  "mappe",
  "md",
  "mht",
  "mov",
  "mp3",
  "mp4",
  "mpp",
  "msg",
  "msi",
  "odp",
  "ods",
  "odt",
  "oft",
  "one",
  "onepkg",
  "ordner",
  "pages",
  "pasta",
  "pbix",
  "pdf",
  "php",
  "phz",
  "png",
  "potm",
  "potx",
  "ppsx",
  "ppt",
  "pptm",
  "pptx",
  "ps1",
  "psd",
  "pub",
  "py",
  "rar",
  "rtf",
  "show",
  "sketch",
  "sldprt",
  "sql",
  "svg",
  "tif",
  "twbx",
  "txt",
  "url",
  "vsd",
  "vsdx",
  "wav",
  "wma",
  "wmv",
  "xls",
  "xlsb",
  "xlsm",
  "xlsx",
  "xltx",
  "xmind",
  "xml",
  "zip"
}

export function isKnownExtension(ext: string): boolean {
  return !!KnownExtension[ext as KnownExtensionType];
}

/**
 * This function lookup for known predefined file type extensions, which are stored as enum,
 * converts them in list of strings & returns that.
 */
export function getKnownFileExtensionsList(): string[] {
  return (Object.keys(KnownExtension) as (keyof number)[]).filter(x =>
    isNaN(Number(x))
  );
}
